
import axios from 'axios'
import { log } from './debug';

import { getServer } from './server';
import { storageRequest } from './localStorageRequest'
import { getDemoAppLocation, getDemowebLocation } from './demo';

let fetching = false; 

const getLocation = (params, callback) => {

    
    if(fetching){
        return; 
    }

    if(!callback)
        return

    fetching=true;
    const debug = params.debug;
    const view = params.view;
    const screen = params.screen; 
    const id = params.id;   
    const test = params.test;         //let go inside with close bussines  
    const demoweb = params.demoweb;   //override the location place, it need takeorder.wathsapp.demoweb=true
    const table = params.table; 

    const phone = params.phone;       //testWhatsApp
    const demowapp=params.demowapp;
    const demoParams = {
        info : params.demoinfo,
        pay: params.demopay,
        fees: params.demofees
    }

    console.log('getLocation params',params); 

    let response;
    const serverEnv=getServer(); 
    const endpoint =serverEnv.server;

    log.setLogs(serverEnv.logs);
    console.log('appLogs: ',serverEnv.logs); 

  
    if(!id){
        response = {
            status:"notId",
            fetchLocation:null,
            code:0,
        }
        console.error('Id not found');
        callback(response);
        return;
    }else if(view=="ticket"){

        const last = storageRequest.get();
        const requestId = last?.request?.id;     
        console.log(`requestId: ${requestId}`);
        //if(requestId!==id){
            response = {
                status:"ticket",
                fetchLocation:null,
                code:0,
            }
            callback(response);
            return; 
       // }
       
    }


    const serviceUrl = `${endpoint}/delivery/${id}`; 
    const storeUrl = `${endpoint}/store/${id}`;
  
    log.message('getLocation','serviceUrl: ',serviceUrl);

    axios.get(serviceUrl)
    .then(async res=>{
                const fetchLocation = mapRemoteLocation(res.data); 
                fetchLocation.current = fetchLocation.containers[0]; 
                const takeorder = fetchLocation.takeorder;
                const settings = fetchLocation.settings
              
                fetchLocation.storeUrl=storeUrl; 
              
                if(fetchLocation.containers.length==0){
                    response = {
                        status:"empty",
                        fetchLocation:fetchLocation,
                        code:200,
                        debug:debug
                    }
                }else if(view==='qr'){
                    
                    response = {
                        status:"qr",
                        fetchLocation:fetchLocation,
                        code:200,
                        view:view,
                        debug:debug
                    }

                }else if(view ==='local'){

                    response = {
                        status:"local",
                        table: table,
                        fetchLocation:fetchLocation,
                        code:200,
                        view:view, 
                        screen:screen,
                        debug:debug
                    }

                }else if( demoweb && takeorder && takeorder.whatsapp &&
                    settings && settings.demoweb && 
                    takeorder.whatsapp.active &&
                    takeorder.whatsapp.open){

                    const demoLocation = await getDemowebLocation(fetchLocation);
                    response = {
                        status:"active",
                        fetchLocation:demoLocation,
                        code:200,
                        view:view, 
                        screen:screen,
                        debug:debug
                    }
                }else if(phone && demowapp){   
                  
                    const location = await getDemoAppLocation(fetchLocation,{
                        isDemo:true, 
                        phone:phone, 
                        deliveryRates: demoParams.fees, 
                        clientInfo:demoParams.info, 
                        payMethods:demoParams.pay
                    });
                       response = {
                        status:"active",
                        fetchLocation:location,
                        code:200,
                        debug:debug
                    }                 
                }else if(takeorder && takeorder.whatsapp &&
                         takeorder.whatsapp.active &&
                         (takeorder.whatsapp.open || test)){

                    response = {
                        status:"active",
                        fetchLocation:fetchLocation,
                        code:200,
                        view:view, 
                        screen:screen,
                        debug:debug
                    }

                }else if(takeorder && takeorder.whatsapp && 
                        takeorder.whatsapp.active && 
                        !takeorder.whatsapp.open){

                        response = {
                            status:"close",
                            fetchLocation:null,
                            code:200,
                            debug:debug
                        }

                }else if(phone){   
                   
                    const location = await getDemoAppLocation(fetchLocation,{
                        isDemo:true, 
                        phone:phone, 
                        deliveryRates: demoParams.fees, 
                        clientInfo:demoParams.info, 
                        payMethods:demoParams.pay
                    }); 
                  
                    log.message('getLocation','getDemoAppLocation', location);

                    response = {
                        status:"active",
                        fetchLocation:location,
                        code:200,
                        debug:debug
                    }
                }else{                  
                    response = {
                        status:"disable",
                        fetchLocation:fetchLocation,
                        code:200,
                        debug:debug
                    }
                }
                fetching=false;
                callback(response); 
            }
        )
    .catch(err=>{
      const message  = err.response? err.response.data: "Error Unknown"; 
      console.log("Error",err); 
      console.error(err); 
     
      response = {
        status:"error",
        fetchLocation:null,
        code:message,
       }
       fetching=false;
       callback(response);
    });
}

const mapRemoteLocation = (remote)=>{
    const place = {
        name:remote.name, 
        address:remote.address, 
        details:remote.details, 
        geopoint:{
            latitude:remote.latitude, 
            longitude:remote.longitude
        }, 
        placeId:remote.placeId
    }; 

    remote.type = remote.type?remote.type.toUpperCase():null
    remote.place= place;

   // console.log('location: ',remote);
    return remote
}




export default getLocation